/** Объект настроек карты.
 * IMapOptions применяются к карте если соответсвтуют ширине запроса
 * Другими словами когда media выражение `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)` === true */

/** Callback, вызываемый перемещении карты */

/** Callback, вызываемый при клике на геообъект */

/** Callback, вызывающийся при открытии всплывающего блока */

/** Callback, вызывающийся при закрытии всплывающего блока */

/** Callback, вызывающийся при входе в режим построения маршрутов */

/** Callback, вызывающийся при выходе из режима построения маршрутов */

/** Callback, вызывающийся при попытке построения маршрутов */

/** Callback, вызывающийся при успешном построении маршрутов */

/** Callback, вызывающийся при изменеии активного маршрута */

/** Callback, вызываемый при успешной загрузке карты */

/** Callback, вызываемый при ошибке загрузки карты */

/** Callback, вызываемый при клике по кнопке панорамы до входа в режим панорамы. */

/** Callback, вызываемый при переходе в режим панорамы */

/** Callback, вызываемый при переходе в режим отсутствия панорамы */

/** Callback, вызываемый при выходе из режима панорамы */

/** Callback, вызываемый при переходе в полноэкранный режим */

/** Callback, вызываемый при выходе из полноэкранного режима */

/** Callback, вызываемый при входе в режим линейки */

/** Callback, вызываемый при выходе из режима линейки */

/** Callback, вызываемый возникновении обработанной ошибки на карте */

/** Статус загрузки карты  */
export var EMapStatus = /*#__PURE__*/function (EMapStatus) {
  EMapStatus[EMapStatus["LOADING"] = 0] = "LOADING";
  EMapStatus[EMapStatus["LOADED"] = 1] = "LOADED";
  return EMapStatus;
}({});

/** Состояние панорам на карте  */
export var EPanoramaState = /*#__PURE__*/function (EPanoramaState) {
  EPanoramaState[EPanoramaState["CLOSED"] = 0] = "CLOSED";
  EPanoramaState[EPanoramaState["PANORAMA"] = 1] = "PANORAMA";
  EPanoramaState[EPanoramaState["NO_PANORAMA"] = 2] = "NO_PANORAMA";
  return EPanoramaState;
}({});

/** Состояние карты  */
export var EMapState = /*#__PURE__*/function (EMapState) {
  EMapState[EMapState["DEFAULT"] = 0] = "DEFAULT";
  EMapState[EMapState["PANORAMA"] = 1] = "PANORAMA";
  EMapState[EMapState["ROUTING"] = 2] = "ROUTING";
  return EMapState;
}({});

/** Опции, которые применяются в зависимости от разрешения экрана */

/** Настройки, связанные с запросами данных */

/** Настройки для первой загрузки карты.
 * Далее частично презаписываются настройками из media(когда становится доступным window) */

/** Настройки карты */

/** Стили, применяемые к контейнеру карты */

/** Внутрееннее состояние карты  */